import {Word} from "./Word";

 export class Example {
    public sentence : string;
    public translation : string;
    public word;
    constructor(exampleData: { sentence: any; translation?: any; word?: any; }){
        this.sentence = exampleData.sentence;
        this.translation = exampleData.translation;
        this.word = exampleData.word;
    }
}